import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

type SettingCardProps = {
  title: string;
  children: React.ReactNode;
};

export const SettingCard = ({ children, title }: SettingCardProps) => {
  return (
    <Card>
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: 1,
          border: "1px solid",
          borderColor: "primary.main",
          bgcolor: "info.main",
          paddingTop: "8px",
          paddingBottom: "8px !important",
        }}
      >
        <Typography variant="body1">{title}</Typography>
        {children}
      </CardContent>
    </Card>
  );
};
